/**
 * * Модель результата обновления названия файла
 */
export class UpdateFileNameResultModel {
  /**Название файла */
  FileName!: string;
  /**Ссылка на файл */
  Url!: string;
  
  constructor(obj?: Partial<UpdateFileNameResultModel>) {
    Object.assign(this, obj);
  }
}